import React from 'react'
import MuiTable from '../../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CAMIONES_LISTOS_PARA_BRUTO } from '../../../../../../config/tables'

export default function TablaCamionesListosParaBrutoView () {
  return <MuiTable id={TABLA_CAMIONES_LISTOS_PARA_BRUTO} />
}
